import { Type } from '@angular/core';
import { ObjectTools } from '../../../tools/object-tools';
import { SolDetail } from '../../../services/detail.service';

export enum DetailStatus {
  open = 'open',
  closing = 'closing',
  closed = 'closed',
}

export class SolDetailsState {
  private static readonly defaultWidth = 450;

  private constructor(
    public readonly detail: SolDetail<any> | undefined,
    public readonly fixed: boolean,
    public readonly currentType: Type<any> | undefined,
    public readonly currentId: string | undefined,
    public readonly status: DetailStatus,
    public readonly dragX: number,
    public readonly dragWidth: number,
    public readonly visible: boolean,
    public readonly closing: boolean,
    public readonly embedded: boolean,
  ) {}

  public static of(): SolDetailsState {
    return new SolDetailsState(
      undefined,
      false,
      undefined,
      undefined,
      DetailStatus.closed,
      -1,
      SolDetailsState.defaultWidth,
      false,
      false,
      false,
    );
  }

  public withEmbedded(embedded: boolean): SolDetailsState {
    if (this.embedded === embedded) {
      return this;
    }
    return this.copy({ embedded });
  }

  public withDetailUpdate(
    detail: SolDetail<any> | undefined,
    fixed: boolean,
    dragWidth: number,
    status: DetailStatus,
  ): SolDetailsState {
    return this.copy({ detail, fixed, dragWidth, status }).recalculateStatus().recalculate();
  }

  public withStatus(status: DetailStatus): SolDetailsState {
    return this.copy({ status }).recalculate();
  }

  public withDragStart(dragX: number, dragWidth: number): SolDetailsState {
    return this.copy({ dragX, dragWidth });
  }

  public withDragEnd(dragWidth: number): SolDetailsState {
    return this.copy({ dragX: -1, dragWidth });
  }

  public withCurrentDetail(currentType: Type<any> | undefined, currentId: string | undefined): SolDetailsState {
    return this.copy({ currentType, currentId });
  }

  private recalculateStatus(): SolDetailsState {
    const status = this.fixed && this.status === DetailStatus.closing ? DetailStatus.closed : this.status;
    return this.copy({ status });
  }

  private recalculate(): SolDetailsState {
    const visible = this.status !== DetailStatus.closed;
    const closing = this.status === DetailStatus.closing;
    return this.copy({ visible, closing });
  }

  private copy(props: Partial<SolDetailsState>): SolDetailsState {
    return ObjectTools.copy<SolDetailsState>(this, props);
  }
}
